import { render, staticRenderFns } from "./Parceiros.vue?vue&type=template&id=ffc3634e&scoped=true"
import script from "./Parceiros.vue?vue&type=script&lang=js"
export * from "./Parceiros.vue?vue&type=script&lang=js"
import style0 from "./Parceiros.vue?vue&type=style&index=0&id=ffc3634e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc3634e",
  null
  
)

export default component.exports